

export default ({ updateState }) => async (params) => {
    /// this must be prudent to use 
    /// 谨慎使用
    const { partialState } = params
    updateState(partialState)
}